module.exports = __webpack_public_path__ + "img/logo_pilot.b251ee09.png";